import { useState } from "react";
import { Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";
import { TopBar } from "./TopBar";
import { supabase } from "../lib/supabase";

export default function ForceChangePassword() {
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) return setError("Password must be at least 8 characters.");
    if (pw !== confirm) return setError("Passwords do not match.");
    setBusy(true);
    try {
      const { data, error: err } = await supabase.functions.invoke("staff-admin", { body: { action: "complete_password_change", new_password: pw } });
      if (err) {
        let msg = err.message;
        try { const j = await err.context?.json?.(); if (j?.error) msg = j.error; } catch { /* keep default message */ }
        throw new Error(msg);
      }
      if (data?.error) throw new Error(data.error);
      const { error: refErr } = await supabase.auth.refreshSession();
      if (refErr) { await supabase.auth.signOut(); return; }
      toast.success("New password set. Welcome to Real Match Matrimony admin.");
    } catch (e2) { setError(e2.message); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="force-change-password" className="rmm-bg min-h-screen">
      <TopBar />
      <div className="flex flex-col items-center px-4 py-10">
      <form onSubmit={submit} className="rmm-card w-full max-w-md space-y-4 p-6 sm:p-8">
        <div>
          <h1 className="font-display text-2xl font-bold text-[#4A000E]">Set your new password</h1>
          <p className="mt-1 text-sm text-[#8C6A6C]">For security, please replace the temporary password with your own before continuing.</p>
        </div>
        <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password (min 8 characters)" autoComplete="new-password" data-testid="force-password-input" className="h-11 w-full rounded-lg border border-[#D4AF37]/50 bg-white px-3 text-sm text-[#1A1515] focus:border-[#7A0016] focus:outline-none" />
        <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" autoComplete="new-password" data-testid="force-confirm-input" className="h-11 w-full rounded-lg border border-[#D4AF37]/50 bg-white px-3 text-sm text-[#1A1515] focus:border-[#7A0016] focus:outline-none" />
        {error && <p data-testid="force-error" className="rounded-lg bg-red-50 px-3 py-2.5 text-sm text-[#A31828]">{error}</p>}
        <button type="submit" disabled={busy} data-testid="force-submit-button" className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-full bg-[#7A0016] text-sm font-semibold text-[#F5E6BA] transition-colors hover:bg-[#4A000E] disabled:opacity-50">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}Set new password
        </button>
        <button type="button" onClick={() => supabase.auth.signOut()} data-testid="force-signout-button" className="inline-flex w-full items-center justify-center gap-1.5 text-sm text-[#8C6A6C] hover:text-[#7A0016]"><LogOut className="h-3.5 w-3.5" />Sign out</button>
      </form>
      </div>
    </div>
  );
}
